import api from './api';

const base = (tenantId) => `/api/harvesting/${tenantId}`;

// ── Taxonomy ────────────────────────────────────────────────────────────────
export const getCategories = (tenantId) =>
  api.get(`${base(tenantId)}/categories`);

// ── Stats (reviewer) ────────────────────────────────────────────────────────
export const getStats = (tenantId) =>
  api.get(`${base(tenantId)}/stats`);

// ── Platform-wide stats (platform staff / admin only) ───────────────────────
export const getPlatformStats = () =>
  api.get('/api/harvesting/platform-stats');

// ── Record listing ──────────────────────────────────────────────────────────
export const getRecords = (tenantId, params) =>
  api.get(`${base(tenantId)}/records`, { params });

export const getMyRecords = (tenantId, params) =>
  api.get(`${base(tenantId)}/records/mine`, { params });

export const getRecord = (tenantId, id) =>
  api.get(`${base(tenantId)}/records/${id}`);

// ── Record mutation ─────────────────────────────────────────────────────────
export const submitRecord = (tenantId, data) =>
  api.post(`${base(tenantId)}/records`, data);

export const updateRecord = (tenantId, id, data) =>
  api.patch(`${base(tenantId)}/records/${id}`, data);

export const deleteRecord = (tenantId, id) =>
  api.delete(`${base(tenantId)}/records/${id}`);

export const reviewRecord = (tenantId, id, data) =>
  api.patch(`${base(tenantId)}/records/${id}/review`, data);
